import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PaymentsSplitClass, PaymentsTypesClass } from '../models/payments-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  GetPaymentsSplitProductsTypesProposalsFilterID(
    idProductsTypesProposalsFilter: number,
    idProductsTypesProposals: number,
  ): Observable<PaymentsSplitClass[]> {
    return this.http
      .get<
        PaymentsSplitClass[]
      >(environment.URL + `/payments/GetPaymentsSplitProductsTypesProposalsFilterID/${idProductsTypesProposalsFilter}/${idProductsTypesProposals}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // obsoleto
  GetPaymentsSplitProductsTypesProposalsID(idProductsTypesProposals: number): Observable<PaymentsSplitClass[]> {
    return this.http
      .get<
        PaymentsSplitClass[]
      >(environment.URL + `/payments/GetPaymentsSplitProductsTypesProposalsID/${idProductsTypesProposals}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetPaymentsTypesProductsTypesProposalsFilterID(
    idProductsTypesProposalsFilter: number,
    idProductsTypesProposals: number,
  ): Observable<PaymentsTypesClass[]> {
    return this.http
      .get<
        PaymentsTypesClass[]
      >(environment.URL + `/payments/GetPaymentsTypesProductsTypesProposalsFilterID/${idProductsTypesProposalsFilter}/${idProductsTypesProposals}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetPaymentsTypesProductsTypesProposalsID(idProductsTypesProposals: number): Observable<PaymentsTypesClass[]> {
    return this.http
      .get<
        PaymentsTypesClass[]
      >(environment.URL + `/payments/GetPaymentsTypesProductsTypesProposalsID/${idProductsTypesProposals}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetPaymentsTypesAll(): Observable<PaymentsTypesClass[]> {
    return this.http.get<PaymentsTypesClass[]>(environment.URL + `/payments/GetPaymentsTypesAll`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetPaymentsTypesProductAll(idProduct: number): Observable<PaymentsTypesClass[]> {
    return this.http
      .get<PaymentsTypesClass[]>(environment.URL + `/payments/GetPaymentsTypesProductAll/${idProduct}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetPaymentsSplitALL(): Observable<PaymentsSplitClass[]> {
    return this.http.get<PaymentsSplitClass[]>(environment.URL + `/payments/GetPaymentsSplitALL`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
